import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { InformationCard } from 'app/components/information-card';
import { breakpointTablet } from 'app/style/breakpoints';
import { spacing3, spacing4 } from 'app/style/spacing';

export const StyledCard = styled(InformationCard)`
    margin-bottom: ${spacing3};

    @media (min-width: ${breakpointTablet}) {
        margin-bottom: ${spacing4};
    }
`;

export const StyledTitle = styled(Typography)`
    font-weight: bold;
    margin-bottom: ${spacing3};

    @media (min-width: ${breakpointTablet}) {
        margin-bottom: ${spacing4};
    }
`;
